import { HabitSchedule, Timestamp } from '@griply/types';

import { getTimeframeSchedules } from './get-timeframe-schedules';

// delegates to getTimeframeSchedules so the overlap predicate cannot diverge
export const hasScheduleInPeriod = (
  schedules: HabitSchedule[],
  periodStart: Timestamp,
  periodEnd: Timestamp,
): boolean =>
  !!getTimeframeSchedules(schedules, {
    startDate: periodStart,
    endDate: periodEnd,
  }).length;
